import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale('es')

const embarquePdf = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || values.quitarImpuestos || false;
  const cantidadJuntoPrecioUnitario = empresa?.cantidadJuntoPrecioUnitario || false;
  // Columna con el P/U ya descontado, a la derecha del P/U
  const precioUnitarioConDescuento = empresa?.precioUnitarioConDescuento === true;
  const widthPUConDescuento = 9;
  const dataSat = values.respuestaFactura.dataSat;
  const direccionEntrega =
    values.respuestaFactura?.dataSat?.direccionEntrega || null;
  let agregarImpDesc = 0;
  const mostrarDescUnidad = empresa?.imprimirDesUnidad;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const proyecto = values.respuestaFactura?.dataSat?.proyecto || [];
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };

  const mostrarClaveSAT = !empresa?.deshabilitarClaveSATCot;
  const mostrarClave = !empresa?.deshabilitarClaveCot;

  const widthClaveSAT = quitarImpuestosRemisiones ? 8 : 9;
  const widthClave = quitarImpuestosRemisiones ? 9 : 12;
  const widthIEPS = 8;

  let widthExtraDescripcion = 0;
  if(!mostrarClaveSAT) widthExtraDescripcion += widthClaveSAT;
  if(!mostrarClave) widthExtraDescripcion += widthClave;
  if (!quitarImpuestosRemisiones && !empresa.imprimirIEPS) {
      widthExtraDescripcion += widthIEPS;
  }

  const conceptos = dataSat.Conceptos.map((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    let agregarImpConcepto = 0;
    let relacionDescuento =
      Number(valueConcepto.Descuento) / Number(valueConcepto.Importe);
    valueConcepto.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
        agregarImpConcepto +=
          valueImpuesto.Importe / (1 - relacionDescuento) -
          valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
        agregarImpConcepto +=
          valueImpuesto.Importe / (1 - relacionDescuento) -
          valueImpuesto.Importe;
      }
      return null;
    });
    agregarImpDesc += agregarImpConcepto;
    // P/U menos el descuento del renglón, en la misma base que la columna P/U
    const precioUnitarioNeto = quitarImpuestosRemisiones
      ? (Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps) / Number(valueConcepto.Cantidad || 1)
      : Number(valueConcepto.ValorUnitario) - Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Cantidad || 1);
    const celdaCantidad = {
      style: "textoTablaChico",
      text: formatCantidad(valueConcepto.Cantidad),
      alignment: "right",
    };
    return [
      { style: "textoTablaChico", text: index + 1, alignment: "center" },
      ...(cantidadJuntoPrecioUnitario ? [] : [celdaCantidad]),
      {
        text: (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad,
        style: "textoTablaChico",
        alignment: "center",
      },
       ...(mostrarClaveSAT ? [{
          text: valueConcepto.ClaveProdServ,
          style: "textoTablaChico",
          alignment: "center",
        }] : []),
        ...(mostrarClave ? [{
          text: valueConcepto.NoIdentificacion,
          style: "textoTablaChico",
          alignment: "center",
        }] : []),
      (() => {
        const textoDescSinObs =
          valueConcepto.Descripcion +
          (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
          (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
          (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
        const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
        const tieneLotes = Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0;
        if (tieneLotes || valueConcepto.DescripcionLarga) {
          return {
            stack: [
              // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
              ...(valueConcepto.DescripcionLarga ? [
                { text: textoDescSinObs, style: "textoTablaChico" },
                { text: valueConcepto.DescripcionLarga, fontSize: 5, color: "#555", margin: [0, 1, 0, 0] },
                ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
              ] : [{ text: textoDesc, style: "textoTablaChico" }]),
              ...(tieneLotes ? [{ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: 5, color: "#555", margin: [0, 2, 0, 0] }] : []),
            ],
            alignment: "left",
          };
        }
        return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
      })(),
      ...(cantidadJuntoPrecioUnitario ? [celdaCantidad] : []),
      {
        stack: [
          {
            text: dineroDisabledMask(
              quitarImpuestosRemisiones
                ? (Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto) / Number(valueConcepto.Cantidad || 1)
                : valueConcepto.ValorUnitario,
              decimalesPrecioUnitarioPdf
            ),
            style: "textoTablaChico",
            alignment: "right",
          },

          ...(
            !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [

                {
                  columns: [
                    {
                      text:
                        round2Decimals(
                          (Number(valueConcepto.Descuento) * 100) /
                          (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))
                        ) + "%:",
                      width: "*",
                      alignment: "left",
                      style: "descuentoPartida",
                      noWrap: true,
                    },
                    {
                      text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento /
                        (Number(valueConcepto.Cantidad || 1)))),
                      width: "auto",
                      alignment: "right",
                      style: "descuentoPartida",
                      noWrap: true,
                    }
                  ],
                  columnGap: 8,
                  margin: [0, 2, 0, 0]
                }]
              : []
          )
        ]
      },
      ...(precioUnitarioConDescuento ? [{
        text: dineroDisabledMask(precioUnitarioNeto, decimalesPrecioUnitarioPdf),
        style: "textoTablaChico",
        alignment: "right",
      }] : []),
      ...(quitarImpuestosRemisiones
        ? []
        : [
          {
            text: dineroDisabledMask(quitarImpuestosRemisiones ? 0 : iva),
            style: "textoTablaChico",
            alignment: "right",
          },
          ...(empresa.imprimirIEPS
            ? [
              {
                text: dineroDisabledMask(ieps),
                style: "textoTablaChico",
                alignment: "right",
              },
            ]
            : []),
        ]),
      {
        stack: [
          {
            text: dineroDisabledMask(
              quitarImpuestosRemisiones
                ? Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto
                : valueConcepto.Importe
            ),
            style: "textoTablaChico",
            alignment: "right",
          },

          ...(
            !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [{
                text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)),
                style: "descuentoPartida",
                alignment: "right",
                margin: [0, 2, 0, 0]
              }]
              : []
          )
        ]
      },
    ];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [
      ...dataSat.Impuestos.Traslados,
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:TrasladosLocales"
      ] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:TrasladosLocales"
      ] || []),
    ];

  let totalImpuestos = 0;

  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA =
      a.Impuesto === "002"
        ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
        : a.Impuesto === "003"
          ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
          : a["@ImpLocTrasladado"];
    const nombreB =
      b.Impuesto === "002"
        ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
        : b.Impuesto === "003"
          ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
          : b["@ImpLocTrasladado"];

    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map(
    (valueImpuesto, indexImpuesto) => {
      let nombre = "";
      if (valueImpuesto.Impuesto === "002") {
        nombre = "IVA";
      } else if (valueImpuesto.Impuesto === "003") {
        nombre = "IEPS";
      } else {
        nombre = valueImpuesto["@ImpLocTrasladado"];
      }

      if (valueImpuesto.TipoFactor === "Tasa") {
        nombre =
          nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
      } else if (valueImpuesto.TipoFactor === "Cuota") {
        nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
      }
      totalImpuestos += valueImpuesto.Importe || valueImpuesto["@Importe"];

      let border = indexImpuesto + 1 === nuevoArrayImpFLOdenado.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(
            valueImpuesto.Importe || valueImpuesto["@Importe"] || 0
          ),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  );

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [
      ...dataSat.Impuestos.Retenciones,
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:RetencionesLocales"
      ] || []),
    ]
    : [
      ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
        "implocal:RetencionesLocales"
      ] || []),
    ];

  const retencionesTotales = nuevoArrayRetFL.map(
    (valueRetencion, indexRetencion) => {
      let nombre = "Retención ";
      if (valueRetencion.Impuesto === "001") {
        nombre = nombre + "ISR";
      } else if (valueRetencion.Impuesto === "002") {
        nombre = nombre + "IVA";
      } else {
        nombre = valueRetencion["@ImpLocRetenido"];
      }

      let border = indexRetencion + 1 === nuevoArrayRetFL.length;
      return [
        {
          border: [true, false, false, border],
          text: nombre,
          style: "subheader",
        },
        {
          border: [false, false, true, border],
          text: dineroDisabledMask(
            valueRetencion.Importe || valueRetencion["@Importe"]
          ),
          style: "textoChico",
          alignment: "right",
        },
      ];
    }
  );

  const totalImpFL =
    dataSat.Impuestos.TotalImpuestosTrasladados +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
      "@TotaldeTraslados"
    ] || 0) || 0;
  const totalRetFL =
    dataSat.Impuestos.TotalImpuestosRetenidos +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"][
      "@TotaldeRetenciones"
    ] || 0) || 0;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = {
      watermark: {
        text: "CANCELADO",
        color: "GRAY",
        opacity: 0.3,
        bold: true,
        italics: false,
        angle: -50,
        fontSize: 110,
      },
    };
  }

  const mostrarBancos = !dataSat?.deshabilitarBanco;
  const filasBanco1 = [
    [
      {
        border: [true, true, false, false],
        text: "Banco:",
        style: "subheader",
      },
      {
        border: [false, true, true, false],
        text: empresa.banco ? empresa.banco : "",
        style: "textoChico",
      },
    ],
    ...(empresa.swiftCode
      ? [
        [
          {
            border: [true, false, false, false],
            text: "Swift Code:",
            style: "subheader",
          },
          {
            border: [false, false, true, false],
            text: empresa.swiftCode ? empresa.swiftCode : "",
            style: "textoChico",
          },
        ],
      ]
      : []),
    ...(empresa.abaCode
      ? [
        [
          {
            border: [true, false, false, false],
            text: "ABA Code:",
            style: "subheader",
          },
          {
            border: [false, false, true, false],
            text: empresa.abaCode ? empresa.abaCode : "",
            style: "textoChico",
          },
        ],
      ]
      : []),
    [
      {
        border: [true, false, false, false],
        text: "Cuenta:",
        style: "subheader",
      },
      {
        border: [false, false, true, false],
        text: empresa.cuentaBanco ? empresa.cuentaBanco : "",
        style: "textoChico",
      },
    ],
    [
      {
        border: [true, false, false, true],
        text: "Cuenta CLABE:",
        style: "subheader",
      },
      {
        border: [false, false, true, true],
        text: empresa.cuentaClabe ? empresa.cuentaClabe : "",
        style: "textoChico",
      },
    ],
  ];
  let observaciones = {};
  if (values.imprimirObservaciones && values.observaciones) {
    observaciones = {
      table: {
        widths: ['*'],
        body: [
          [
            {
              border: [true, true, true, false],
              text: "Observaciones:",
              margin: [0, 0, 0, 5],
              style: "header",
            },
          ],
          [
            {
              border: [true, false, true, true],
              text: values.observaciones,
              margin: [0, 0, 0, 5],
              style: "textoChico",
            },
          ],
        ],
      },
      layout: {
        defaultBorder: false,
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 1 : 1;
        },
        vLineWidth: function (i, node) {
          return i === 0 || i === node.table.widths.length ? 1 : 1;
        },
        hLineColor: function (i, node) {
          return "#adaaaa";
        },
        vLineColor: function (i, node) {
          return "#adaaaa";
        },
        hLineStyle: function (i, node) {
          if (i === 0 || i === node.table.body.length) {
            return null;
          }
          return { dash: { length: 2, space: 1 } };
        },
        vLineStyle: function (i, node) {
          if (i === 0 || i === node.table.widths.length) {
            return null;
          }
          return { dash: { length: 2 } };
        },
      },
    };
  }

  const arraySiHayRetenciones =
    totalRetFL > 0
      ? [
        [
          {
            border: [true, false, false, true],
            text: "TOTAL PAGO:",
            style: "header",
            fillColor: "#e8e8e8",
          },
          {
            border: [false, false, true, true],
            text: dineroDisabledMask(dataSat.Total),
            style: "header",
            fillColor: "#e8e8e8",
            alignment: "right",
          },
        ],
      ]
      : [];

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;

  let vendedorTable = [];

  if (empresa.vendedorVentas && values.vendedor) {
    const vendedor = values.vendedor;
    vendedorTable.push([
      {
        colSpan: 2,
        table: {
          widths: ["17.5%", "82.5%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              { text: "Vendedor :", style: "subheader" },
              {
                text:
                  vendedor.nombre +
                  (vendedor.apellidoPaterno
                    ? " " + vendedor.apellidoPaterno
                    : "") +
                  (vendedor.apellidoMaterno
                    ? " " + vendedor.apellidoMaterno
                    : ""),
                style: "textoChico",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ]);
  }

  var dd = {
    ...cancelado,
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              ...HeaderEmpresaCard(empresa, mostrarRegimen, true,
                {
                  border: [false, false, false, false],
                  table: {
                    headerRows: 1,
                    widths: ["100%"],

                    body: [
                      [
                        {
                          text: "N° Embarque:",
                          style: "subheader",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text:
                            (dataSat.Serie ? dataSat.Serie : "E") +
                            " - " +
                            dataSat.Folio,
                          style: "textoChico",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text: "Moneda:",
                          style: "subheader",
                          alignment: "center",
                        },
                      ],
                      [
                        {
                          text: dataSat.Moneda,
                          style: "textoChico",
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                }),
            ],
          ],
        },
      },
      {
        text:
          "Embarque N° " +
          (dataSat.Serie ? dataSat.Serie : "E") +
          " - " +
          dataSat.Folio,
        style: "tableHeaderIzquierda",
      },
      {
        style: "tableExample",
        table: {
          widths: ["60%", "40%"],
          layout: {
            defaultBorder: false,
          },

          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      { text: "Nombre del cliente :", style: "subheader" },
                      { text: dataSat.Receptor.Nombre, style: "textoChico" },
                    ],
                    [
                      { text: "Fecha:", style: "subheader" },
                      {
                        text: moment(dataSat.Fecha).locale("es").format("LL"),
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "Lugar de expedicion:", style: "subheader" },
                      { text: dataSat.LugarExpedicion, style: "textoChico" },
                    ],
                    [
                      { text: "Metodo de pago :", style: "subheader" },
                      {
                        text:
                          dataSat.MetodoPago === "PUE"
                            ? "PUE - Pago en una sola exhibición"
                            : "PPD - Pago en parcialidades o diferido",
                        style: "textoChico",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                table: {
                  widths: ["40%", "60%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    ...(empresa?.mostrarProyectoVentas
                      ? [
                        [
                          { text: "Proyecto:", style: "subheader" },
                          {
                            text: proyecto,
                            style: "textoChico",
                          },
                        ],
                      ]
                      : []),
                    [
                      { text: "Orden de compra:", style: "subheader" },
                      { text: dataSat.pedido, style: "textoChico" },
                    ],
                    ...(dataSat.req
                      ? [
                        [
                          {
                            text: "Req: ",
                            style: "subheader",
                            alignment: "left",
                          },
                          { text: dataSat.req, style: "textoChico" },
                        ]
                      ]
                      : []),
                    [
                      { text: "Condiciones de pago:", style: "subheader" },
                      {
                        text:
                          dataSat.condicion === 1
                            ? "Contado"
                            : "Crédito (" +
                            (dataSat?.Receptor?.diasCredito
                              ? dataSat?.Receptor?.diasCredito
                              : "0") +
                            " días)",
                        style: "textoChico",
                      },
                    ],
                    ...(direccionEntrega?.destino
                      ? [[
                        { text: "Destino:", style: "subheader" },
                        {
                          text: direccionEntrega?.destino,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    ...(direccionEntrega?.embarque
                      ? [[
                        { text: "Embarque:", style: "subheader" },
                        {
                          text: direccionEntrega?.embarque,
                          style: "textoChico",
                        },
                      ]]
                      : []),
                    [
                      { text: "Direccion de Entrega:", style: "subheader" },
                      {
                        text: direccionEntrega
                          ? (direccionEntrega.calle || "") +
                          (direccionEntrega?.numeroCalle
                            ? " #" + direccionEntrega?.numeroCalle
                            : "") +
                          " " +
                          (direccionEntrega.colonia || "")
                          : "",
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "C.P.:", style: "subheader" },
                      { text: direccionEntrega?.cp?.cp, style: "textoChico" },
                    ],
                    [
                      { text: "Estado:", style: "subheader" },
                      {
                        text: direccionEntrega?.estado?.nombre,
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "Ciudad:", style: "subheader" },
                      {
                        text: direccionEntrega?.municipio?.nombre,
                        style: "textoChico",
                      },
                    ],
                    [
                      { text: "Pais:", style: "subheader" },
                      {
                        text: direccionEntrega?.pais?.nombre,
                        style: "textoChico",
                      },
                    ],
                    ...(dataSat?.atencion
                      ? [[
                        { text: "Atención a: ", style: "subheader" },
                        { text: dataSat?.atencion, style: "textoChico" },
                      ]]
                      : []),
                  ],
                },
                layout: "noBorders",
              },
            ],
            ...vendedorTable,
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tableExample",
        table: {
          widths: quitarImpuestosRemisiones
            ? [
              "2%", //Número de item
              ...(cantidadJuntoPrecioUnitario ? [] : ["7%"]), //Cantidad
              "8%", //Unidad
              ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),//"8%" Clave SAT
              ...(mostrarClave ? [`${widthClave}%`] : []),//"9%" Clave
              `${36 + widthExtraDescripcion - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`, //Descripción
              ...(cantidadJuntoPrecioUnitario ? ["7%"] : []), //Cantidad
              "15%", //P/U
              ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), //P/U c/Desc.
              "15%", //Importe
            ]
            : [
              "2%",
              ...(cantidadJuntoPrecioUnitario ? [] : ["4%"]),
              "6%",
              ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
              ...(mostrarClave ? [`${widthClave}%`] : []),
              `${28 + widthExtraDescripcion - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
              ...(cantidadJuntoPrecioUnitario ? ["4%"] : []),
              "10.5%",
              ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []), //P/U c/Desc.
              "8%",
              ...(empresa.imprimirIEPS ? ["8%"] : []),
              "12.5%",
            ],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              { text: "", style: "tituloTabla" },
              ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cant", style: "tituloTabla" }]),
              { text: "Unidad", style: "tituloTabla" },
              ...(mostrarClaveSAT ? [{ text: "Clave SAT", style: "tituloTabla" }] : []),
              ...(mostrarClave ? [{ text: "Clave", style: "tituloTabla" }] : []),
              { text: "Descripción", style: "tituloTabla" },
              ...(cantidadJuntoPrecioUnitario ? [{ text: "Cant", style: "tituloTabla" }] : []),
              { text: "P/U", style: "tituloTabla" },
              ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.", style: "tituloTabla" }] : []),
              ...(quitarImpuestosRemisiones
                ? []
                : [
                  { text: "IVA", style: "tituloTabla" },
                  ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
                ]),
              { text: "Importe", style: "tituloTabla" },
            ],
            ...conceptos,
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            return rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff";
          },
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tablaSinMargen",
        table: {
          widths: ["70%", "30%"],
          layout: {
            defaultBorder: true,
          },
          body: [
            [
              {
                table: {
                  widths: ["30%", "70%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, !mostrarBancos],
                        text: "Cantidad con letra:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, !mostrarBancos],
                        text:
                          "**( " +
                          numeroALetra(dataSat.Total, dataSat.Moneda) +
                          " )**",
                        style: "textoChico",
                        fontSize: 7,
                      },
                    ],
                    ...mostrarBancos ? [
                      ...filasBanco1,
                    ] : [],
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
              {
                table: {
                  widths: ["35%", "65%"],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                    [
                      {
                        border: [true, true, false, false],
                        text: "Subtotal:",
                        style: "subheader",
                      },
                      {
                        border: [false, true, true, false],
                        text: dineroDisabledMask(
                          quitarImpuestosRemisiones
                            ? dataSat.SubTotal + totalImpuestos + agregarImpDesc
                            : dataSat.SubTotal
                        ),
                        style: "textoChico",
                        alignment: "right",
                      },
                    ],
                    ...((
                      quitarImpuestosRemisiones
                        ? dataSat.Descuento + agregarImpDesc
                        : dataSat.Descuento > 0
                    )
                      ? [
                        [
                          {
                            border: [true, false, false, false],
                            text: "Descuento:",
                            style: "subheader",
                          },
                          {
                            border: [false, false, true, false],
                            text: "- " + dineroDisabledMask(
                              quitarImpuestosRemisiones
                                ? dataSat.Descuento + agregarImpDesc
                                : dataSat.Descuento
                            ),
                            style: "textoChico",
                            alignment: "right",
                          },
                        ],
                      ]
                      : []
                    ),
                    ...(quitarImpuestosRemisiones ? [] : impuestosTotales),
                    [
                      {
                        border: [true, false, false, true],
                        text: "TOTAL:",
                        style: "header",
                        fillColor: "#e8e8e8",
                      },
                      {
                        border: [false, false, true, true],
                        text: dineroDisabledMask(total),
                        style: "header",
                        fillColor: "#e8e8e8",
                        alignment: "right",
                      },
                    ],
                    ...retencionesTotales,
                    ...arraySiHayRetenciones,
                  ],
                },
                layout: {
                  hLineWidth: function (i, node) {
                    return i === 0 || i === node.table.body.length ? 1 : 1;
                  },
                  vLineWidth: function (i, node) {
                    return i === 0 || i === node.table.widths.length ? 1 : 1;
                  },
                  hLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  vLineColor: function (i, node) {
                    return "#adaaaa";
                  },
                  hLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return null;
                    }
                    return { dash: { length: 2, space: 1 } };
                  },
                  vLineStyle: function (i, node) {
                    if (i === 0 || i === node.table.widths.length) {
                      return null;
                    }
                    return { dash: { length: 2 } };
                  },
                },
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      observaciones,
      ...(empresa.textoAdicionalPedidosCotizaciones
        ? [
          {
            style: "tableExample",
            table: {
              widths: ["100%"],
              body: [
                [
                  {
                    text: empresa.textoAdicionalPedidosCotizaciones,
                    style: "textoAdicionalPedidosCotizaciones",
                    border: [true, true, true, true],
                    margin: [0, 0, 0, 5],
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
              hLineWidth: function (i, node) {
                return i === 0 || i === node.table.body.length ? 1 : 1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 1;
              },
              hLineColor: function (i, node) {
                return "#adaaaa";
              },
              vLineColor: function (i, node) {
                return "#adaaaa";
              },
              hLineStyle: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                  return null;
                }
                return { dash: { length: 2, space: 1 } };
              },
              vLineStyle: function (i, node) {
                if (i === 0 || i === node.table.widths.length) {
                  return null;
                }
                return { dash: { length: 2 } };
              },
            },
          },
        ]
        : []),
    ],
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: {
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      tablaSinMargen: {
        margin: [0, 0, 0, 0],
      },
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      textoChico: {
        fontSize: 8,
      },
      textoAdicionalPedidosCotizaciones: {
        fontSize: empresa.tamañoTextoAdicionalPedidosCotizaciones || 8,
      },
      textoChicoData: {
        fontSize: 6,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
      textoTablaChico: {
        fontSize: 6,
        italics: false,
      },
      descuentoPartida: {
        fontSize: 5,
        color: "#777",
      }
    },
    pageSize: "LETTER",
  };
  return dd;
};
export default embarquePdf;
